module.exports = "../fonts/vendor/vendor/typeface-inter/Inter Web/Inter-BoldItalic.woff?3b22d0067ce6baaa9edd770ee2b688bf";